import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const HandPointer = ({
  color = 'white',
  width = 15,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={getSemanticTextColor(color)}
        d="M6.87802 1.375C6.87802 0.615608 7.50046 0 8.26827 0C9.03608 0 9.65852 0.615609 9.65852 1.375V6.08929C9.65852 5.32989 10.281 4.71429 11.0488 4.71429C11.8166 4.71429 12.439 5.32989 12.439 6.08929V6.875C12.439 6.11561 13.0614 5.5 13.8293 5.5C14.5971 5.5 15.2195 6.11561 15.2195 6.875V8.44643C15.2195 7.68704 15.8419 7.07143 16.6098 7.07143C17.3776 7.07143 18 7.68704 18 8.44643V13.3571V13.5536C18 13.6498 17.99 13.7437 17.971 13.8343C17.7329 15.779 16.0583 17.2857 14.0279 17.2857H11.0488H10.8502C9.44477 17.2857 8.20986 16.5639 7.50377 15.4746L3.33725 10.6941C2.83594 10.1189 2.90099 9.25068 3.48256 8.75487C4.06412 8.25905 4.94197 8.32339 5.44329 8.89858L6.87802 10.5447V1.375ZM7.67245 19.6429C7.67245 19.2089 8.02813 18.8571 8.46688 18.8571H16.4111C16.8499 18.8571 17.2056 19.2089 17.2056 19.6429V21.2143C17.2056 21.6482 16.8499 22 16.4111 22H8.46688C8.02813 22 7.67245 21.6482 7.67245 21.2143V19.6429Z"
      />
    </svg>
  </DefaultIconWrapper>
);
